angular.module('ihestiaWidgets.pza')
  .factory('ihestiaPzaChooseReportModalHelper', ['iHestiaCommonModalHelper', 'ihestiaPzaFileSvc',
    function(iHestiaCommonModalHelper, ihestiaPzaFileSvc) {
      var ChooseReportModalHelper = function() {
        var self = this;

        this.programId = null;

        /**
         * Czyścimy dane pomocnicze powiązane z modalem
         * zazwyczaj odpalane na $destroy modala
         * @return {ChooseReportModalHelper} self
         */
        this.clearData = function() {
          self.programId = null;

          return self;
        };


        /**
         * Pokazujemy modal wyboru raportu
         * @param  {int} programId id programu
         * @return {ChooseReportModalHelper} self
         */
        this.showChooseReportModal = function(programId) {
          self.programId = programId;
          iHestiaCommonModalHelper.showModal('ihestiaPzaChooseReport');

          return self;
        };

        /**
         * Zamykamy modal wyboru raportu
         * @param  {int} programId id programu
         * @return {ChooseReportModalHelper} self
         */
        this.hideChooseReportModal = function() {
          self.clearData();
          iHestiaCommonModalHelper.hideModal('ihestiaPzaChooseReport');

          return self;
        };


        /**
         * Ściąganie raportu po fileId
         * @param  {String} fileId id pliku
         * @return {Promise}
         */
        this.downloadReport = function(fileId) {
          return ihestiaPzaFileSvc.downloadFile(fileId);
        };

      };

      return new ChooseReportModalHelper();
    }]);